import $ from 'jquery';
import { isValidDropdown, isValidText, isValidNumber, isValidCcNumber, isValidCvc, isValidBsb, isValidCheckbox, isValidCreditCardName, isValidExpiryDate, isValidAccountName } from '../form-elements/validation';

// helper: payment form field type and validation function
export const paymentFieldTypes = () => [
    {
        type: 'dropdown',
        tag: 'select',
        func: isValidDropdown
    },
    {
        type: 'text',
        tag: 'input',
        func: isValidText
    },
    {
        type: 'cardname',
        tag: 'input',
        func: isValidCreditCardName
    },
    {
        type: 'number',
        tag: 'input',
        func: isValidNumber
    },
    {
        type: 'ccNumber',
        tag: 'input',
        func: isValidCcNumber
    },
    {
        type: 'ccExp',
        tag: 'input',
        func: isValidExpiryDate
    },
    {
        type: 'accountName',
        tag: 'input',
        func: isValidAccountName
    },
    {
        type: 'bsb',
        tag: 'input',
        func: isValidBsb
    },
    {
        type: 'cvc',
        tag: 'input',
        func: isValidCvc
    },
    {
        type: 'checkbox',
        tag: 'input',
        func: isValidCheckbox
    }
];

// get processing fee amount based on payment type and amount
export const getProcessingFee = currentPaymentData => {
    const $form = $('.c-stc-donation-form');
    const $processingFeeAmount = $form.find('#CheckBoxContro-processing-fee #processing-amount');

    // call api if donation amount and payment type exists
    if (currentPaymentData.currentPaymentType && currentPaymentData.currentDonationAmount) {
        const $apiUrl = $form.find('#processing-fee-api').data('api-url');
        const paymentTypeQuery = {
            'paypal-payment': 'PayPal',
            'cc-form': 'CreditCard',
            'debit-form': 'DirectDebit'
        };

        // eslint-disable-next-line max-len
        const $queryUrl = `${$apiUrl}?amount=${currentPaymentData.currentDonationAmount}&paymenttype=${paymentTypeQuery[currentPaymentData.currentPaymentType]}`;

        fetch($queryUrl)
            .then(response => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error('Request failed');
            })
            .then(jsonResponse => $processingFeeAmount.html(jsonResponse.data))
            .catch(err => {
                console.log(err);
            });
    }
};

// handle checkbox labels change.
// its triggered on select payment change and donation freq change.
export const updateCheckboxLabels = item => {
    const $hiddenPaymentField = $('#hidPaymentType').val();
    if (item === 'Recurring') {
        $('.label-once').addClass('hidden');
        $('.label-processing-fee-once').addClass('hidden');
        $('.label-processing-fee-monthly').removeClass('hidden');
        if ($hiddenPaymentField === 'cc-form') {
            $('.label-monthly-cc').removeClass('hidden');
            $('.label-monthly-dd').addClass('hidden');
            $('.checkbox-error-msg')[0].innerHTML = 'You must agree to our T&C and privacy policy';
        } else {
            $('.label-monthly-dd').removeClass('hidden');
            $('.label-monthly-cc').addClass('hidden');
            $('.checkbox-error-msg')[0].innerHTML = 'You must agree to our Direct Debit Services Agreement';
        }
    }
    if (item === 'Single') {
        $('.label-once').removeClass('hidden');
        $('.label-monthly-cc').addClass('hidden');
        $('.label-monthly-dd').addClass('hidden');
        $('.checkbox-error-msg')[0].innerHTML = 'You must agree to our T&C and privacy policy';
        $('.label-processing-fee-once').removeClass('hidden');
        $('.label-processing-fee-monthly').addClass('hidden');
    }
};

// handle select payment method
export const donateSelectCardForm = currentPaymentData => {
    const $option = $('.js-card-form-select select');
    const $hiddenPaymentField = $('#hidPaymentType');

    if ($option.length === 0) return;

    $('.js-card-form-option-item').addClass('hide');

    const setSelectedCardForm = () => {
        // update processing fee API call
        currentPaymentData.currentPaymentType = $option.find(':selected').data('form-id');
        $hiddenPaymentField.val(currentPaymentData.currentPaymentType);
        const $donateFreq = $('.donate-hidden-freq').val();
        updateCheckboxLabels($donateFreq);
        getProcessingFee(currentPaymentData);
        // showing the selected payment form and hiding the others.
        $(`#${$option.find(':selected').data('form-id')}`).removeClass('hide').siblings('.js-card-form-option-item').addClass('hide');
    };

    $option.change(() => {
        setSelectedCardForm();
    });

    setSelectedCardForm();
};

export const getPaymentType = () => {
    const $option = $('.js-card-form-select .payment-type select');
    const currType = $option.find(':selected').data('form-id');
    return currType;
};



// WEBPACK FOOTER //
// ./src/components/donation-payment/c-donation-payment.js